var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-check form-switch text-center"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"change":_vm.onCheckChanged}})])}
var staticRenderFns = []

export { render, staticRenderFns }